import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useShell } from '../../shell/ShellContext';
import { getArenaSocket } from './arenaSocket';

/* The Taco Stand — invite landing. A friend opens /taco-stand/invite/:code */
const styles = `
  .tsi-page { min-height: calc(100vh - 60px); background: linear-gradient(180deg,#FFF8F1,#fff 60%);
    display:flex; align-items:center; justify-content:center; padding:32px 20px;
    font-family:-apple-system,BlinkMacSystemFont,'SF Pro Display','Helvetica Neue',Arial,sans-serif;
    --brand:#FF7A00; --ink:#1D1D1F; --ink2:#6E6E73; --ink3:#86868B; --surface:#F5F5F7; --surface2:#EBEBED;
    --green:#34C759; --green-ink:#1B873F; --hair:#EBEBED; --paper:#FFFDF8; --paper-edge:#EFE4D2; --mono:'SF Mono',ui-monospace,'Menlo',monospace; --ease:cubic-bezier(0.16,1,0.3,1); }
  .tsi-page * { box-sizing:border-box; }
  .tsi-card { width:480px; max-width:96vw; background:#fff; border:1px solid var(--hair); border-radius:24px; overflow:hidden; box-shadow:0 18px 50px rgba(120,70,10,.12); text-align:center; animation:tsicardin .4s var(--ease) both; }
  @keyframes tsicardin { from { opacity:0; transform:translateY(14px) scale(.98); } to { opacity:1; transform:none; } }
  .tsi-awn { height:14px; background:repeating-linear-gradient(90deg,var(--brand) 0 30px,#FFE7CC 30px 60px); }
  .tsi-body { padding:36px 36px 32px; }
  .tsi-host { width:104px; height:104px; border-radius:50%; background:radial-gradient(circle at 50% 38%,#FFD9A8,#FFB55C); margin:0 auto 18px; display:flex; align-items:center; justify-content:center; font-size:56px; position:relative; box-shadow:inset 0 -6px 14px rgba(180,90,0,.18); }
  .tsi-host .steam { position:absolute; top:-16px; left:50%; transform:translateX(-50%); display:flex; gap:7px; }
  .tsi-host .steam i { width:3px; height:18px; border-radius:3px; background:rgba(255,122,0,.28); animation:tsisteam 2.6s ease-in-out infinite; }
  .tsi-host .steam i:nth-child(2){ animation-delay:.5s; height:24px; } .tsi-host .steam i:nth-child(3){ animation-delay:1s; }
  @keyframes tsisteam { 0%{opacity:0;transform:translateY(4px)} 40%{opacity:.9} 100%{opacity:0;transform:translateY(-10px)} }
  .tsi-eyebrow { font-size:11px; font-weight:700; letter-spacing:.16em; text-transform:uppercase; color:var(--brand); margin-bottom:10px; }
  .tsi-title { font-size:26px; font-weight:700; letter-spacing:-.02em; margin-bottom:6px; color:var(--ink); }
  .tsi-title b { color:var(--brand); }
  .tsi-sub { font-size:14px; color:var(--ink2); margin-bottom:24px; line-height:1.5; }
  .tsi-seg { display:inline-flex; background:rgba(0,0,0,.05); border-radius:11px; padding:4px; gap:2px; margin-bottom:14px; }
  .tsi-seg button { padding:8px 18px; border-radius:8px; font-size:13px; font-weight:500; color:var(--ink2); border:none; background:none; cursor:pointer; font-family:inherit; }
  .tsi-seg button.on { background:#fff; color:var(--ink); box-shadow:0 1px 3px rgba(0,0,0,.08); }
  .tsi-chips { display:flex; flex-wrap:wrap; gap:8px; justify-content:center; margin-bottom:20px; }
  .tsi-chip { padding:7px 14px; border-radius:980px; border:1.5px solid #D2D2D7; font-size:13px; color:var(--ink2); background:#fff; cursor:pointer; font-family:inherit; }
  .tsi-chip.on { background:var(--ink); border-color:var(--ink); color:#fff; }
  .tsi-btn { width:100%; display:inline-flex; align-items:center; justify-content:center; gap:8px; background:var(--ink); color:#fff; padding:15px 28px; border-radius:980px; font-size:16px; font-weight:600; border:none; cursor:pointer; font-family:inherit; transition:all .25s var(--ease); }
  .tsi-btn:hover { transform:translateY(-1px); opacity:.92; }
  .tsi-btn:active { transform:scale(.97); opacity:.92; }
  .tsi-btn.secondary { background:var(--surface); color:var(--ink); margin-top:10px; }
  .tsi-gate { display:flex; flex-direction:column; gap:10px; }
  .tsi-in { background:var(--surface); border:none; border-radius:12px; font-size:15px; font-family:inherit; padding:14px 16px; color:var(--ink); outline:none; text-align:center; }
  .tsi-in:focus { box-shadow:0 0 0 3px rgba(0,0,0,.06); }
  .tsi-sent { font-size:14px; color:var(--green-ink); font-weight:500; }
  .tsi-err { font-size:13px; color:#FF3B30; margin-top:6px; }
  .tsi-host-name { display:inline-flex; align-items:center; gap:7px; background:var(--surface); border-radius:980px; padding:5px 12px 5px 6px; font-size:13px; font-weight:600; color:var(--ink); margin-bottom:20px; }
  .tsi-host-av { width:24px; height:24px; border-radius:50%; background:var(--ink); color:#fff; display:flex; align-items:center; justify-content:center; font-size:10px; font-weight:700; overflow:hidden; }
  .tsi-host-av img { width:100%; height:100%; object-fit:cover; }
  .tsi-dots { display:flex; gap:7px; justify-content:center; margin:18px 0; }
  .tsi-dots i { width:9px; height:9px; border-radius:50%; background:var(--brand); animation:tsiwait 1.3s ease-in-out infinite; }
  .tsi-dots i:nth-child(2){ animation-delay:.18s; } .tsi-dots i:nth-child(3){ animation-delay:.36s; }
  @keyframes tsiwait { 0%,100%{opacity:.25;transform:scale(.8)} 50%{opacity:1;transform:scale(1.15)} }

  @media (prefers-reduced-motion: reduce) {
    .tsi-page *, .tsi-page *::before, .tsi-page *::after {
      animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important;
    }
  }
`;

export default function TradeArenaInvite() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { leagues, sleeperUser } = useShell();

  const [status, setStatus] = useState('loading'); // loading | ready | invalid | joining | found
  const [host, setHost] = useState(null);
  const [rosterType, setRosterType] = useState('own');
  const [selectedLeagueId, setSelectedLeagueId] = useState('');
  const [foundData, setFoundData] = useState(null);
  const [email, setEmail] = useState('');
  const [sleeperInput, setSleeperInput] = useState('');
  const [emailState, setEmailState] = useState('idle');

  const socketRef = useRef(null);
  const dynastyLeagues = (leagues || []).filter((l) => l.leagueId);

  useEffect(() => {
    if (dynastyLeagues.length > 0 && !selectedLeagueId) setSelectedLeagueId(dynastyLeagues[0].leagueId || '');
  }, [dynastyLeagues.length]); // eslint-disable-line

  useEffect(() => {
    if (!user) { setStatus('ready'); return; } // logged-out: show landing + gate
    const sock = getArenaSocket(user.id, user.sleeperUsername, sleeperUser?.user_id);
    socketRef.current = sock;

    const onInfo = (info) => {
      if (!info?.found) { setStatus('invalid'); return; }
      setHost(info); setStatus('ready');
    };
    const onMatch = (data) => { setFoundData(data); setStatus('found'); setTimeout(() => navigate(`/taco-stand/room/${data.sessionId}`, { state: data }), 1500); };
    const onInvalid = () => setStatus('invalid');

    sock.on('arena:invite_info', onInfo);
    sock.on('arena:match_found', onMatch);
    sock.on('arena:invite_invalid', onInvalid);
    sock.emit('arena:check_invite', { code });

    return () => { sock.off('arena:invite_info', onInfo); sock.off('arena:match_found', onMatch); sock.off('arena:invite_invalid', onInvalid); };
  }, [user, code, sleeperUser, navigate]);

  const handleJoin = () => {
    const league = dynastyLeagues.find((l) => l.leagueId === selectedLeagueId);
    socketRef.current?.emit('arena:join_invite', {
      code,
      rosterMode: rosterType,
      leagueId: rosterType === 'own' ? selectedLeagueId || null : null,
      leagueName: rosterType === 'own' ? league?.name || null : null,
    });
    setStatus('joining');
  };

  const handleMagicLink = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setEmailState('sending');
    try {
      const res = await fetch('/api/auth/request-magic-link', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), returnUrl: `/taco-stand/invite/${code}`, sleeperUsername: sleeperInput.trim() || undefined }),
      });
      setEmailState(res.ok ? 'sent' : 'error');
    } catch { setEmailState('error'); }
  };

  const hostName = host?.hostUsername || 'A friend';

  return (
    <>
      <style>{styles}</style>
      <div className="tsi-page">
        <div className="tsi-card">
          <div className="tsi-awn" />
          <div className="tsi-body">

            {status === 'invalid' ? (
              <>
                <div className="tsi-host">🌮</div>
                <div className="tsi-title">This table's gone</div>
                <div className="tsi-sub">The invite expired or was already claimed. Head to the window and step up for a fresh game.</div>
                <button className="tsi-btn" onClick={() => navigate('/taco-stand')}>Go to the window →</button>
              </>
            ) : status === 'found' ? (
              <>
                <div className="tsi-host"><div className="steam"><i /><i /><i /></div>🌮</div>
                <div className="tsi-eyebrow">Kitchen opening</div>
                <div className="tsi-title">You're in.</div>
                <div className="tsi-sub">Sitting you down across from {foundData?.opponentSleeperUsername || hostName}…</div>
                <div className="tsi-dots"><i /><i /><i /></div>
              </>
            ) : status === 'joining' ? (
              <>
                <div className="tsi-host"><div className="steam"><i /><i /><i /></div>🌮</div>
                <div className="tsi-title">Pulling up a chair…</div>
                <div className="tsi-sub">Opening the table with {hostName}.</div>
                <div className="tsi-dots"><i /><i /><i /></div>
              </>
            ) : (
              <>
                <div className="tsi-host"><div className="steam"><i /><i /><i /></div>🌮</div>
                <div className="tsi-eyebrow">You've been invited</div>
                <div className="tsi-title"><b>{hostName}</b> saved you a seat</div>
                <div className="tsi-sub">A private one-on-one at The Taco Stand. Pick what you're bringing and sit down — scout them, then two minutes of dealing.</div>

                {user ? (
                  <>
                    <div className="tsi-seg">
                      <button className={rosterType === 'own' ? 'on' : ''} onClick={() => setRosterType('own')}>Your roster</button>
                      <button className={rosterType === 'random' ? 'on' : ''} onClick={() => setRosterType('random')}>Surprise me</button>
                    </div>
                    {rosterType === 'own' && dynastyLeagues.length > 0 && (
                      <div className="tsi-chips">
                        {dynastyLeagues.slice(0, 5).map((l) => (
                          <button key={l.sleeperLeagueId} className={`tsi-chip${selectedLeagueId === l.leagueId ? ' on' : ''}`} onClick={() => setSelectedLeagueId(l.leagueId)}>{l.name || l.sleeperLeagueId}</button>
                        ))}
                      </div>
                    )}
                    <button className="tsi-btn" onClick={handleJoin}>🌮 Sit down — join the game →</button>
                    <button className="tsi-btn secondary" onClick={() => navigate('/taco-stand')}>Not now</button>
                  </>
                ) : (
                  <>
                    {emailState === 'sent' ? (
                      <div className="tsi-sent">Link sent. Open it on this device and you'll drop right into {hostName}'s table.</div>
                    ) : (
                      <form className="tsi-gate" onSubmit={handleMagicLink}>
                        <input className="tsi-in" placeholder="Your Sleeper username" value={sleeperInput} onChange={(e) => setSleeperInput(e.target.value)} disabled={emailState === 'sending'} />
                        <input className="tsi-in" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} disabled={emailState === 'sending'} />
                        <button className="tsi-btn" type="submit" disabled={emailState === 'sending' || !email.trim()}>{emailState === 'sending' ? 'Sending…' : 'Sign in & sit down →'}</button>
                      </form>
                    )}
                    {emailState === 'error' && <div className="tsi-err">Something went wrong. Try again.</div>}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
